import { useCallback } from "react";
import { useTranslation } from "react-i18next";

/**
 * Toggle between English and Croatian, persisted via i18n languageChanged handler.
 */
export function useLanguageToggle() {
  const { i18n } = useTranslation();

  const toggleLanguage = useCallback(() => {
    i18n.changeLanguage(i18n.language === "en" ? "hr" : "en");
  }, [i18n]);

  return { language: i18n.language, toggleLanguage };
}
